import { motion } from "framer-motion";

export const ComingSoon = ({ products }) => {
  const soon = products.filter((p) => p.status === "coming_soon");

  if (!soon.length) return null;

  return (
    <section
      id="coming-soon"
      data-testid="coming-soon-section"
      className="bg-cream py-28 md:py-36 border-t border-ink/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="mb-16 md:mb-20 md:flex md:items-end md:justify-between gap-10">
          <div>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="text-xs tracking-[0.4em] uppercase text-amberbrand mb-4"
            >
              03 — What's Next
            </motion.p>
            <div className="overflow-hidden">
              <motion.h2
                initial={{ y: "100%" }}
                whileInView={{ y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                className="font-serif text-5xl md:text-7xl text-ink tracking-tighter"
              >
                The pantry <span className="italic text-olive">grows.</span>
              </motion.h2>
            </div>
          </div>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.3 }}
            className="mt-6 md:mt-0 max-w-sm text-sm font-light text-ink/60 leading-relaxed"
          >
            PhudG began with oil — but purity shouldn't stop at oil. Staples,
            ground and sourced with the same obsession, are on their way.
          </motion.p>
        </div>

        <div className="grid sm:grid-cols-3 gap-8">
          {soon.map((p, i) => (
            <motion.article
              key={p.slug}
              data-testid={`coming-soon-card-${p.slug}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="group"
            >
              <div className="relative overflow-hidden rounded-3xl border border-ink/10">
                <img
                  src={p.image}
                  alt={`${p.name} — coming soon`}
                  loading="lazy"
                  className="w-full aspect-square object-cover grayscale-[35%] opacity-80 transition-all duration-700 ease-out group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105"
                />
                <div className="absolute top-4 right-4">
                  <span className="rounded-full bg-ink/80 backdrop-blur-sm px-4 py-1.5 text-[10px] tracking-[0.3em] uppercase text-gold">
                    Coming Soon
                  </span>
                </div>
              </div>
              <div className="pt-6 px-1">
                <h3 className="font-serif text-2xl md:text-3xl text-ink/80">{p.name}</h3>
                <p className="text-sm font-light text-ink/50 mt-1">{p.tagline}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
